import { Component, OnDestroy, Inject, OnInit } from '@angular/core';
import {
  SuiModal,
  ComponentModalConfig,
  ModalSize,
} from '@richardlt/ng2-semantic-ui';
import { DOCUMENT } from '@angular/common';
interface IConfirmModalContext {
  question: string;
  title?: string;
  confirmationText?: string;
  cancelText?: string;
}
@Component({
  selector: 'app-confirm-modal',
  template: `
    <h3 id="header" class="ui primary header">
      {{ modal.context.title }}
      <i class="link times icon" (click)="modal.deny(undefined)"></i>
    </h3>

    <div class="content">
      <div class="ui basic center aligned segment">
        <p class="question-text">{{ modal.context.question }}</p>
        <div class="actions">
          <button
            class="ui  basic primary button"
            (click)="modal.deny(undefined)"
            *ngIf="modal.context.cancelText != ''"
          >
            {{ modal.context.cancelText ? modal.context.cancelText : 'No' }}
          </button>
          <button
            class="ui primary button"
            (click)="modal.approve(undefined)"
            *ngIf="modal.context.confirmationText != ''"
            autofocus
          >
            {{
              modal.context.confirmationText
                ? modal.context.confirmationText
                : 'Yes'
            }}
          </button>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./confirm-modal.component.scss'],
})
export class ConfirmModalComponent implements OnInit, OnDestroy {
  constructor(
    @Inject(DOCUMENT) private document,
    public modal: SuiModal<IConfirmModalContext, void, void>
  ) {}
  ngOnInit() {
    this.document.body.classList.remove('panel');
  }
  // s
  ngOnDestroy(): void {
    this.document.body.classList.add('panel');
  }
}

export class ConfirmModal extends ComponentModalConfig<
  IConfirmModalContext,
  void,
  void
> {
  constructor(
    title: string,
    question: string,
    size: ModalSize = ModalSize.Small,
    confirmationText?: string,
    cancelText?: string
  ) {
    super(ConfirmModalComponent, {
      title,
      question,
      confirmationText,
      cancelText,
    });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
